// Service Worker registration for image caching
export const registerServiceWorker = () => {
  if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw-cache.js')
        .then((registration) => {
          console.log('SW registered: ', registration);

          // Check for updates periodically
          setInterval(() => {
            registration.update();
          }, 60000); // Check every minute
        })
        .catch((registrationError) => {
          console.warn('SW registration failed: ', registrationError);
        });
    });
  }
};

// Preload critical images with service worker
export const preloadWithSW = (imageUrls: string[]) => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then(() => {
      // Service worker is ready, images will be cached automatically on fetch
      imageUrls.forEach(url => {
        fetch(url).catch(err => console.warn('Preload failed for:', url, err));
      });
    });
  }
};